export enum DeviceType {
    WashWatch = 'WashWatch',
    WirelessMonitor = 'WirelessMonitor',
}